class MOQ {
  constructor() {

    if(moq100Settings.enabled)
      this.init()
  }

  init(){
    
    $.getJSON('/cart.js', function(res) {

      const buttonSubmit = document.getElementById('button__submit')
      const note = document.querySelector('.moq-100-note')
      
      let totalItems = 0;
      const items = res.items;
      // const join = excludedProduct ? excludedProduct.join("|").toLowerCase() : ""

    
        
        const testArray = items.filter(item => {
          const keys = Object.keys(item.properties)

          if(keys.includes('__MOQ100')) {
            return item
          }
        })


      
        if (testArray && testArray.length > 0) {
          totalItems = testArray.reduce((a, b) => {
            return a + b.quantity
          }, 0)


          const total = parseInt(totalItems)

  


          const active = (isActive)=>{
            if(isActive){
              buttonSubmit.classList.remove('disabled__before-loaded')
              note.style.display = "none"
            }else{
              buttonSubmit.classList.add('disabled__before-loaded')
              note.style.display = "block"
            }
          }
    
    
          if (total >= moq100Settings.minOrder && total <= moq100Settings.maxOrder) {
              active()
          } 


        }

      
      
  

      /**
      if (moq100Settings.minOrder === 0) {
        if (total <= moq100Settings.maxOrder || total >= moq100Settings.minOrder) {
            active(true)
        } else {
            active()
        }
    } else if (moq100Settings.maxOrder === 0) {
        if (total >= moq100Settings.minOrder) {
            active(true)
        } else {
            active()
        }
    } else {
        if (total >= moq100Settings.minOrder && total <= moq100Settings.maxOrder) {
            active(true)
        } else {
            active()
        }
    }
      **/


  

      
    })
  }
}

const moqRules = function(params) {
  new MOQ()
}


moqRules()